// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'site',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'star_rate',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'book_type',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'online',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
